import { WalkMeData } from '@core/walk-me/models/walk-me-data.interface';

export const segmentId = '1646648';

export interface WalkMeWindow extends Window {
  walkme_ready: () => void;
  walkMeData?: WalkMeData;
  WalkMeAPI?: {
    getLastSegmentsResults: () => {
      [segmentId]?: {
        conditionsTree?: {
          ConditionsTree?: unknown;
        };
      };
    };
  };
  _walkmeConfig: unknown;
  _walkMe?: {
    removeWalkMe?: () => void;
  };
}
